import { Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule, DatePipe } from '@angular/common';
import { RetakeRequest } from 'src/app/queries/generated';

@Component({
  selector: 'lv-list-retake-requests',
  templateUrl: './list-retake-requests.component.html',
  styleUrls: ['./list-retake-requests.component.scss'],
  imports: [CommonModule, TranslateModule, DatePipe]
})
export class ListRetakeRequestsComponent {
  @Input() retakeRequests!: RetakeRequest[];
}
